export default class RouterJump {
  constructor (sourceView, targetView, sourceObject, options) {
    this.sourceView = sourceView
    this.targetView = targetView
    this.sourceObject = sourceObject
    this.options = options
  }
}
